<script lang="ts" setup>
import type { RefSymbol } from '@vue/reactivity';
import useMainStore from '~/shared/store';

const mainStore = useMainStore();
const progress = ref(0);

const simulateLoading = () => {
 if (progress.value < 100) {
  const step = Math.floor(Math.random() * 10) + 1;
  progress.value = Math.min(progress.value + step, 100);
 } 
};

const allContentLoaded = computed(() => mainStore.allContentLoaded); 

watch(allContentLoaded, (newValue) => {
  if (!newValue) {
    const interval = setInterval(() => {
      simulateLoading();
      if (allContentLoaded.value) {
        clearInterval(interval);
        progress.value = 0;
      }
    }, 100);
  }
});

onMounted(() => {
  if (!allContentLoaded.value) {
    simulateLoading();
  }
});

</script>

<template>
  <div
    v-if="!mainStore.allContentLoaded"
    class="search-preloader"
  >
    <div class="search-preloader__progress" :style="{ width: `${progress}%` }"></div>
  </div>
</template>

<style lang="scss" scoped>

.search-preloader {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 6px;
  z-index: 9999;

  &__progress {
    height: 100%;
    background-color: $control-content_orange; 
    transition: width 0.5s ease;
  }
}
</style>
